import { FormattedMessage, FormattedPlural } from "react-intl";
import AmountContainer from "app/pages/.shared/AmountContainer";
import AmountSign from "app/pages/.shared/AmountSign/AmountSign";
import PropTypes from "prop-types";
import "./BaggageInfo.scss";
import { BAGGAGE_TYPES } from "app/constants";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";

const BAGGAGE_TRANSLATION_KEYS = {
	[BAGGAGE_TYPES.HAND_BAGGAGE]: {
		singular: "quotation.luggage.handbag.singular.label",
		plural: "quotation.luggage.handbag.plural.label",
	},
	[BAGGAGE_TYPES.CABIN_BAGGAGE]: {
		singular: "quotation.luggage.cabin.singular.label",
		plural: "quotation.luggage.cabin.plural.label",
	},
	[BAGGAGE_TYPES.CHECKED_BAGGAGE]: {
		singular: "quotation.luggage.singular.label",
		plural: "quotation.luggage.plural.label",
	},
	[BAGGAGE_TYPES.TRAIN_BAGGAGE]: {
		singular: "price.detail.transport.luggage.label.singular",
		plural: "price.detail.transport.luggage.label.plural",
	},
};

const BaggageInfo = ({ baggageList }) => {
	if (!baggageList || baggageList.length === 0) {
		return null;
	}

	const filteredBaggageList = baggageList.filter(baggage => baggage.quantity > 0);

	if (filteredBaggageList.length === 0) {
		return null;
	}

	const renderPrice = baggage => {
		if (baggage?.offered) {
			return (
				<Typography variant={TYPOGRAPHY_VARIANTS.REGULAR} component="p">
					<FormattedMessage id="general.offered" />
				</Typography>
			);
		}

		if (baggage?.included) {
			return (
				<Typography variant={TYPOGRAPHY_VARIANTS.REGULAR} component="p">
					<FormattedMessage id="general.included" />
				</Typography>
			);
		}

		return (
			<AmountContainer
				isBold={false}
				prefix={<AmountSign sign="+" />}
				amount={baggage?.price}
				className="baggage-info__value-amount"
			/>
		);
	};

	return (
		<div className="baggage-info" data-testid="baggage-info">
			{filteredBaggageList.map(baggage => {
				return (
					<div
						className="baggage-info__item"
						key={baggage.type}
						data-testid={`baggage-info-${baggage.type}`}
					>
						<div className="baggage-info__label">
							<Typography variant={TYPOGRAPHY_VARIANTS.REGULAR} component="p">
								{baggage.quantity}x{" "}
								<FormattedPlural
									value={baggage.quantity}
									one={
										<FormattedMessage
											id={BAGGAGE_TRANSLATION_KEYS[baggage.type].singular}
											values={{
												count: baggage.quantity,
											}}
										/>
									}
									other={
										<FormattedMessage
											id={BAGGAGE_TRANSLATION_KEYS[baggage.type].plural}
											values={{
												count: baggage.quantity,
											}}
										/>
									}
								/>
							</Typography>

							{baggage?.details?.length > 0 && (
								<Typography
									variant={TYPOGRAPHY_VARIANTS.SMALL}
									component="p"
									className="baggage-info__details"
								>
									{baggage?.details}
								</Typography>
							)}
						</div>

						<div className="baggage-info__value">{renderPrice(baggage)}</div>
					</div>
				);
			})}
		</div>
	);
};

BaggageInfo.propTypes = {
	baggageList: PropTypes.arrayOf(
		PropTypes.shape({
			type: PropTypes.string.isRequired,
			quantity: PropTypes.number.isRequired,
			included: PropTypes.bool.isRequired,
			price: PropTypes.number,
		})
	).isRequired,
};

export default BaggageInfo;
